import { HttpClient } from "@angular/common/http"
import { Injectable } from "@angular/core"
import { API_HOST } from "environments/environment"

@Injectable({
    providedIn: 'root'
})
export class ProjectsApiService {

    constructor(private http: HttpClient) { }

    public create(data:any) {
        return this.http.post(API_HOST + 'projects', data)
    }

    public update(id, data:any) {
        return this.http.put(API_HOST + `projects/${id}`, data)
    }

    public delete(id:string) {
        return this.http.delete(API_HOST + `projects/${id}`)
    }

    public getDeleted() {
        return this.http.get(API_HOST + 'projects/deleted')
    }

    public restore(id: string) {
        return this.http.put(API_HOST + `projects/${id}/restore`, {})
    }

    public get(params) {

        return this.http.get(API_HOST + `projects?` + new URLSearchParams(params).toString())
    }

    public getProjectMarkouts(id:string) {
        return this.http.get(API_HOST + `projects/${id}/markouts`)
    }

    public getById(id:string) {
        return this.http.get(API_HOST + `projects/${id}`)
    }

    public updateWip(id: string, data: { contractAmount: number, completedAmount: number, contactFirm?: string, contactName?: string, contactPhone?: string, contactPhoneExt?: string, isWipManual?: boolean }) {
        return this.http.put(API_HOST + `projects/${id}/wip`, data)
    }
}